import { GET_PERSONAL_INFO } from '../actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_PERSONAL_INFO:
      if (action.payload.data && action.payload.data.success) {
        return {
          status: action.payload.data.success,
          user: action.payload.data.personalInfo
        }
      } else {
        return {
          status: false,
          message: 'Server error'
        }
      }
  }
  return state
}
